module.exports = __webpack_public_path__ + "static/media/Grid.5ea8a0b1.svg";